import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export const RecordSection = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "pt-3 pb-5 pl-6 pr-3 flex flex-col gap-3 shadow-xs rounded-xl border border-grey-200 bg-white",
        className,
      )}
      {...props}
    />
  );
};

const RecordSectionTitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "flex items-center justify-between gap-2 font-medium text-grey-900 relative h-9",
        className,
      )}
      {...props}
    />
  );
};

const RecordSectionDataGroup = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={twMerge("flex flex-col gap-4", className)} {...props} />
  );
};

const RecordSectionDataItem = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={twMerge("flex flex-col gap-0.5", className)} {...props} />
  );
};

const RecordSectionDataItemLabel = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "font-medium text-sm text-grey-500 flex gap-1.5 items-center",
        className,
      )}
      {...props}
    />
  );
};

const RecordSectionDataItemValue = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={twMerge("flex-1 text-grey-800", className)} {...props} />
  );
};

const RecordSectionDataList = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "flex flex-col border border-grey-200 bg-grey-25 rounded-lg divide-y divide-grey-100 overflow-hidden -ml-4 -mr-1 -mb-3",
        className,
      )}
      {...props}
    />
  );
};

const RecordSectionDataListItem = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "flex items-center justify-between py-3.5 px-4 font-medium hover:bg-grey-50 transition bg-grey-25 gap-3",
        className,
      )}
      {...props}
    />
  );
};

const RecordSectionDataListItemTitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "text-sm text-grey-900 flex items-center gap-1.5",
        className,
      )}
      {...props}
    />
  );
};

const RecordSectionDataListItemProperties = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "text-sm text-grey-500 flex items-center gap-3",
        className,
      )}
      {...props}
    />
  );
};

export {
  RecordSectionTitle,
  RecordSectionDataList,
  RecordSectionDataListItem,
  RecordSectionDataListItemTitle,
  RecordSectionDataListItemProperties,
  RecordSectionDataGroup,
  RecordSectionDataItem,
  RecordSectionDataItemLabel,
  RecordSectionDataItemValue,
};
